import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DeleteIcon, InfoIcon, SuccessIcon } from '@/icons';
export const Toast = ({ message, description, status, id: toastId, removeToast, }) => {
    const toastStyles = {
        success: 'bg-vjwSuccess text-white',
        error: 'bg-vjwDanger text-white',
        info: 'bg-vjwPrimary text-white',
    };
    const icons = {
        success: _jsx(SuccessIcon, {}),
        error: _jsx(DeleteIcon, {}),
        info: _jsx(InfoIcon, { className: 'size-5' }),
    };
    return (_jsx("div", { className: `${toastStyles[status]} mb-2 flex w-64 justify-between gap-2 items-start rounded p-2 text-sm font-semibold`, children: _jsxs("div", { className: 'flex gap-2 items-center', children: [!!icons[status] && icons[status], _jsxs("div", { className: 'flex-1 font-normal', children: [_jsx("div", { className: 'font-semibold text-sm', children: message }), description && _jsx("div", { className: 'text-xs font-normal', children: description })] })] }) }));
};
